import { ThrowStmt } from '@angular/compiler';

export class Action {
    title: string;
    img: string;
    url: string;
    id: number;
    order: number;
    newTab: boolean;
    disable: boolean;
    constructor(title, id, img, url, order, newTab = false, disable = false) {
        this.title = title;
        this.img = img;
        this.url = url;
        this.order = order;
        this.id = id;
        this.newTab = newTab;
        this.disable = disable;
    }
}
export class ActionServices {
    title: string;
    hasSlider: boolean;
    actions: Action[];
    animatedBoxId: string;
    constructor(title) {
        this.hasSlider = false;
        this.title = title;
        this.actions = [];
    }
}
